import { render, staticRenderFns } from "./BalancesPlanDetailsForm.vue?vue&type=template&id=656c1444&"
import script from "./BalancesPlanDetailsForm.vue?vue&type=script&lang=js&"
export * from "./BalancesPlanDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports